import './Slogan.css';

const Slogan = () => {
    return (
        <div className="slogan">
            <div className="slogan__content container">
                <h1 className="slogan__title">
                    Getting feedback is great, but it's even better when it's combined with Feedbacky
                </h1>
            </div>
        </div>
    );
}

export default Slogan;